import React from 'react'
import { Box, Typography, Button, Modal, IconButton } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'

interface LegalOverlayProps {
  open: boolean
  content: {
    title: string
    content: string
  }
  onClose: () => void
}

const LegalOverlay: React.FC<LegalOverlayProps> = ({
  open,
  content,
  onClose,
}) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="legal-modal-title"
      className="legal-overlay-modal"
    >
      <Box className="legal-overlay-content">
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          mb={2}
        >
          <Typography id="legal-modal-title" variant="h5">
            {content.title}
          </Typography>
          <IconButton onClick={onClose} size="small">
            <CloseIcon />
          </IconButton>
        </Box>
        <Box
          className="legal-content"
          dangerouslySetInnerHTML={{ __html: content.content }}
        />
        <Box mt={3} textAlign="right">
          <Button onClick={onClose} variant="contained">
            Close
          </Button>
        </Box>
      </Box>
    </Modal>
  )
}

export default LegalOverlay
